import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, MailCheck } from 'lucide-react';
import { authApi } from '../../services/api';
import { AuthLayout, Fehlermeldung } from './AuthLayout';

export default function PasswortVergessenPage() {
  const [email, setEmail] = useState('');
  const [gesendet, setGesendet] = useState(false);
  const [fehler, setFehler] = useState<unknown>(null);
  const [laeuft, setLaeuft] = useState(false);

  async function absenden(e: FormEvent) {
    e.preventDefault();
    setFehler(null);
    setLaeuft(true);
    try {
      await authApi.passwortVergessen({ email });
      setGesendet(true);
    } catch (err) {
      setFehler(err);
    } finally {
      setLaeuft(false);
    }
  }

  if (gesendet) {
    return (
      <AuthLayout titel="Prüfen Sie Ihr Postfach">
        <div className="flex gap-3 text-sm text-gray-700">
          <MailCheck className="h-5 w-5 shrink-0 text-green-600" />
          <p>
            {/* Bewusst ohne Auskunft darueber, ob es das Konto gibt: sonst
                waere dieses Formular eine Auskunftsstelle darueber, wer bei
                uns Kunde ist. */}
            Falls zu dieser Adresse ein Konto besteht, haben wir eine E-Mail mit
            einem Code zum Zurücksetzen gesendet.
          </p>
        </div>
        <Link
          to={`/passwort-zuruecksetzen?email=${encodeURIComponent(email)}`}
          className="mt-6 block w-full rounded-md bg-primary-600 px-4 py-2 text-center text-sm font-medium text-white hover:bg-primary-700"
        >
          Code eingeben
        </Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      titel="Passwort zurücksetzen"
      untertitel="Wir senden Ihnen einen Code an Ihre E-Mail-Adresse."
      fusszeile={
        <Link to="/login" className="text-primary-600 hover:underline">
          Zurück zur Anmeldung
        </Link>
      }
    >
      <Fehlermeldung fehler={fehler} />
      <form onSubmit={absenden} className="space-y-4">
        <input
          type="email"
          required
          autoFocus
          autoComplete="username"
          placeholder="ihre@firma.de"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
        />
        <button
          type="submit"
          disabled={laeuft}
          className="flex w-full items-center justify-center rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700 disabled:opacity-60"
        >
          {laeuft && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          Code anfordern
        </button>
      </form>
    </AuthLayout>
  );
}
